import { TimelineMax } from "gsap";
import { SplashText } from "../modules/SplashText";
import { IDimConfig } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { SymbolMultiplyCounter } from "../../symbol/SymbolMultiplyCounter";
import { JumpWildState } from "../../jumpingWild/JumpingWildController";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { TranslationConfig } from "../../../../translations/TranslationConfig";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";

export class SplashViewExtraWild extends BaseView implements SplashView  {
    
    protected _txt:SplashText;
    protected _spine:PIXI.spine.Spine;

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(1.75, 1.75),
                position: new PIXI.Point(360, 300),
                layout: {
                    left: new PIXI.Point(360, 300),
                    right: new PIXI.Point(360, 300)
                }
            },
            portrait: {
                scale: new PIXI.Point(1.75, 1.75),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };
    
    protected _mult:SymbolMultiplyCounter;
    protected _timeLine:TimelineMax;

    protected DEFAULT_TXT_STYLE:TextStyleOptions;

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
    }

    protected initAnimations():void{
        this._txt = new SplashText(Translation.translate(TranslationConfig.EXTRA_WILD),this.DEFAULT_TXT_STYLE);
        this._mult = new SymbolMultiplyCounter();
        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset("JWild"));

        this._txt.position = new PIXI.Point(370,160);
        this._txt.anchor.set(0.5,0);

        this._spine.position = new PIXI.Point(360,380);
        this._mult.position = new PIXI.Point(360,380);

        this._spine.scale.set(1.25,1.25);

        this._mult.pivot.set(0, 70);
        this._mult.scale.set(1, 1);
        this._mult.text = "X5";

        this.addChild(this._txt);
        this.addChild(this._spine);
        this.addChild(this._mult);

        this.visible = false;
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    public play():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = true;
        this._mult.visible = false;
        this._timeLine.add(() => this._spine.state.setAnimation(0, JumpWildState.IDLE, true),0);
        this._timeLine.add(() => this._spine.state.setAnimation(0, JumpWildState.MERGE, false),2);
        this._timeLine.add(() => { this._mult.visible = true } ,2);
        this._timeLine.add(() => this._spine.state.setAnimation(0, JumpWildState.MERGE_IDLE, true),3);
        this._timeLine.add(() => this._spine.state.setAnimation(0, JumpWildState.MERGE_WIN, false),4);
        return new TimelineMax();
    }

    public stop():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = false;
        return this._timeLine;
    }
}
